/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Model, { attr } from '@ember-data/model';

/**
 * Minimal read-only model for Ember Data relationship.
 * Use ScheduledContentUpdateService for all operations (create, update, cancel).
 */
export default class ScheduledContentUpdate extends Model {
  @attr('number') declare appId: number;
  @attr('number') declare entityId: number;
  @attr('number') declare versionId: number;
  @attr('number') declare entityType: number;
  @attr('string') declare status: string;
  @attr('string') declare contentUpdateType: string;
  @attr('date') declare changeAt: Date;
  @attr('number') declare adminId: number;
  @attr('string') declare metadata: string;
  @attr('date') declare createdAt: Date;
  @attr('date') declare updatedAt: Date;
}
